import { supabase } from '@/lib/supabase';

/** Encerra ('encerrada') ou reabre ('ativa') uma publicação da sua empresa. */
export async function setOpportunityStatus(id, status) {
  const { error } = await supabase.rpc('set_opportunity_status', { p_id: id, p_status: status });
  if (error) throw new Error(error.message);
}